'use strict';

var ChartSponsorForecastFlightViewport = function ChartSponsorForecastFlightViewport(ChartViewport, chartGroups, chartTiles, momentService) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./Scales')(momentService);
  var Chart = function Chart(container) {
    var groups = chartGroups('date');
    var tiles = chartTiles('data', 'time', 'flights');
    ChartViewport.call(this, container, chartParams, chartScales, groups, tiles);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartSponsorForecastFlightViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsTiles', 'MomentService'];
module.exports = ChartSponsorForecastFlightViewport;